import { render, staticRenderFns } from "./Publipostage.vue?vue&type=template&id=d3d4e1cc"
import script from "./Publipostage.vue?vue&type=script&lang=js"
export * from "./Publipostage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports